import { isMqMobile } from '../common/responsive';

export function setBodyLayout(layoutName: string) {
    removeBodyLayout();
    document.body.className += ' ad-layout-' + layoutName;
}

export function removeBodyLayout() {
    document.body.className = document.body.className.replace(/ ad-layout-\w*/g, '');
}

export function removeAdSlotClass(slotId: string, className: string) {
    const placementElem: HTMLElement = document.getElementById(slotId);
    placementElem.className = placementElem.className.replace(' ' + className, '');
}

const isOrientationHandlerRegistered: {[slotId: string]: boolean} = {};

export function scaleMailAd(slotId: string) {
    const placementElem: HTMLElement = document.getElementById(slotId);
    // sirka AdSlotu pevne nastavena v DFP
    const fromWidth = 730;
    // vyska reklamy, zadava Tomas v backoffice (cislo z rozsahu 500 - 3000px)
    const contentHeight = Math.max(500, Math.min(3000,
        parseInt(placementElem.getAttribute('data-content-height'), 10) || 1000,
    ));

    if (isMqMobile()) {
        const toWidth = placementElem.clientWidth;
        const scale = Math.min(toWidth / fromWidth, 1);

        const childElem: HTMLElement = placementElem.firstChild as HTMLElement;
        if (childElem.tagName === 'DIV') {
            childElem.style.transform = childElem.style.webkitTransform = `scale(${scale})`;
            childElem.style.transformOrigin = '50% 0';
        }

        if (!isOrientationHandlerRegistered[slotId]) {
            isOrientationHandlerRegistered[slotId] = true;
            let timer;
            const orientationChangeHandler = () => {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    scaleMailAd(slotId);
                }, 500);
            };

            window.addEventListener('orientationchange', orientationChangeHandler);

            const removeOrientationHandler = () => {
                clearTimeout(timer);
                placementElem.removeEventListener('slotWillUnmount', removeOrientationHandler, false);
                // One time only
                window.removeEventListener('orientationchange', orientationChangeHandler, false);
                isOrientationHandlerRegistered[slotId] = false;
            };
            placementElem.addEventListener('slotWillUnmount', removeOrientationHandler);
        }

        placementElem.style.height = `${contentHeight * scale}px`;
    } else {
        placementElem.style.height = `${contentHeight}px`;
    }
}
